"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferPaymentAction = exports.BurnPaymentAction = exports.NonFungiblePaymentAssetClass = exports.FungiblePaymentAssetClass = exports.parsePaymentAction = exports.parsePaymentAssetClass = exports.UpdateTargetSelectionSwapTrait = exports.UpdateTargetSelectionRemoveTrait = exports.UpdateTargetSelectionEquipTrait = exports.UpdateTargetSelectionClassVariant = exports.UpdateTargetSelectionTraitVariant = exports.UpdateTargetSwapTrait = exports.UpdateTargetRemoveTrait = exports.UpdateTargetEquipTrait = exports.UpdateTargetClassVariant = exports.UpdateTargetTraitVariant = exports.hashUpdateTarget = exports.parseUpdateTargetByKind = exports.parseUpdateTarget = exports.UpdateState = exports.PaymentMethod = exports.Trait = exports.Avatar = exports.AvatarClass = exports.TraitGate = exports.PaymentState = exports.VariantOption = exports.parseAttributeType = exports.formatAttributeType = exports.VariantMetadata = exports.VERIFIED_PAYMENT_MINT_PREFIX = exports.UPDATE_STATE_PREFIX = exports.PAYMENT_METHOD_PREFIX = exports.TRAIT_CONFLICTS_PREFIX = exports.TRAIT_PREFIX = exports.AVATAR_PREFIX = exports.AVATAR_CLASS_PREFIX = void 0;
const anchor = __importStar(require("@project-serum/anchor-0.26.0"));
const js_sha256_1 = require("js-sha256");
const avatar_1 = require("./avatar");
exports.AVATAR_CLASS_PREFIX = "avatar_class";
exports.AVATAR_PREFIX = "avatar";
exports.TRAIT_PREFIX = "trait";
exports.TRAIT_CONFLICTS_PREFIX = "trait_conflicts";
exports.PAYMENT_METHOD_PREFIX = "payment_method";
exports.UPDATE_STATE_PREFIX = "update_state";
exports.VERIFIED_PAYMENT_MINT_PREFIX = "verified_payment_mint";
class VariantMetadata {
    constructor(name, id, status, options) {
        this.name = name;
        this.id = id;
        this.status = status;
        this.options = options;
    }
    formatForIx() {
        const opts = [];
        for (const opt of this.options) {
            const ixOpt = opt.formatForIx();
            opts.push(ixOpt);
        }
        return {
            name: this.name,
            id: this.id,
            status: this.status,
            options: opts,
        };
    }
}
exports.VariantMetadata = VariantMetadata;
function formatAttributeType(attributeType) {
    switch (attributeType) {
        case "Optional":
            return { optional: {} };
        case "Essential":
            return { essential: {} };
    }
}
exports.formatAttributeType = formatAttributeType;
function parseAttributeType(attributeType) {
    switch (Object.keys(attributeType)[0]) {
        case "optional":
            return "Optional";
        case "essential":
            return "Essential";
        default:
            throw new Error(`Unknown AttributeType: ${attributeType}`);
    }
}
exports.parseAttributeType = parseAttributeType;
class VariantOption {
    constructor(variantId, optionId, paymentDetails, traitGate, name) {
        this.name = name;
        this.variantId = variantId;
        this.optionId = optionId;
        this.paymentDetails = null;
        this.traitGate = null;
        if (paymentDetails) {
            this.paymentDetails = paymentDetails;
        }
        if (traitGate) {
            this.traitGate = traitGate;
        }
    }
    formatForIx() {
        let tg = null;
        if (this.traitGate !== null) {
            tg = this.traitGate.formatForIx();
        }
        return {
            variantId: this.variantId,
            optionId: this.optionId,
            paymentDetails: this.paymentDetails,
            traitGate: tg,
        };
    }
}
exports.VariantOption = VariantOption;
class PaymentState {
    constructor(paymentMethod, currentAmount, requiredAmount) {
        this.paymentMethod = paymentMethod;
        this.currentAmount = currentAmount;
        this.requiredAmount = requiredAmount;
    }
    isPaid() {
        console.log("checking if paid, currentAmount: %s, requiredAmount: %s", this.currentAmount.toString(), this.requiredAmount.toString());
        return this.currentAmount.gte(this.requiredAmount);
    }
}
exports.PaymentState = PaymentState;
class TraitGate {
    constructor(operator, traits) {
        this.traits = traits;
        if (typeof operator === "string") {
            if (operator === "AND") {
                this.operator = operator;
            }
            if (operator === "OR") {
                this.operator = operator;
            }
            return;
        }
        if ("And" in operator || "and" in operator) {
            this.operator = "AND";
            return;
        }
        if ("Or" in operator || "or" in operator) {
            this.operator = "OR";
            return;
        }
        if (this.operator === undefined) {
            throw new Error(`unable to parse operator: ${operator}`);
        }
    }
    formatForIx() {
        switch (this.operator) {
            case "AND": {
                return { operator: { and: {} }, traits: this.traits };
            }
            case "OR": {
                return { operator: { or: {} }, traits: this.traits };
            }
            default:
                throw new Error(`unable to format trait gate: ${JSON.stringify(this)}`);
        }
    }
}
exports.TraitGate = TraitGate;
class AvatarClass {
    constructor(mint, traitIndex, paymentIndex, attributeMetadata, variantMetadata, globalRenderingConfigUri) {
        this.mint = mint;
        this.traitIndex = traitIndex;
        this.paymentIndex = paymentIndex;
        this.attributeMetadata = attributeMetadata;
        this.variantMetadata = variantMetadata;
        this.globalRenderingConfigUri = globalRenderingConfigUri;
    }
    findVariantOption(variantId, optionId) {
        const variantMetadata = this.variantMetadata.find((vm) => vm.id === variantId);
        if (variantMetadata === undefined) {
            throw new Error(`variantId ${variantId} not found`);
        }
        const option = variantMetadata.options.find((opt) => opt.optionId === optionId);
        if (option === undefined) {
            throw new Error(`optionId ${optionId} not found`);
        }
        return option;
    }
}
exports.AvatarClass = AvatarClass;
class Avatar {
    constructor(address, avatarClass, mint, imageUri, traits, variants) {
        this.updateStates = [];
        this.address = address;
        this.avatarClass = avatarClass;
        this.mint = mint;
        this.imageUri = imageUri;
        this.traits = traits;
        this.variants = variants;
    }
    // true if the provided attribute ids are not currently occupied
    isAttributeSlotAvailable(attributeIds) {
        for (const trait of this.traits) {
            for (const attributeId of trait.attributeIds) {
                if (attributeIds.includes(attributeId)) {
                    return false;
                }
            }
        }
        return true;
    }
    // return traits which occupy the given attributeIds, will return empty array if no match
    getTraitsByAttributeId(attributeIds) {
        const traits = [];
        for (const trait of this.traits) {
            for (const attributeId of trait.attributeIds) {
                if (attributeIds.includes(attributeId)) {
                    traits.push(trait.traitAddress);
                }
            }
        }
        return traits;
    }
    // return all in progress updates for the avatar
    // TODO: add equip/remove traits when feature is ready
    async inProgressUpdates(client) {
        const updateStates = [];
        // check class variant updates
        for (const variant of this.variants) {
            const target = new UpdateTargetClassVariant(variant.variantId, variant.optionId);
            const updateState = avatar_1.updateStatePDA(this.address, target);
            const updateStateData = await client.getUpdateState(updateState);
            if (updateStateData === null) {
                continue;
            }
            updateStates.push(updateStateData);
        }
        // check trait variant updates
        for (const trait of this.traits) {
            for (const variant of trait.variantSelection) {
                const target = new UpdateTargetTraitVariant(variant.variantId, variant.optionId, trait.traitAddress);
                const updateState = avatar_1.updateStatePDA(this.address, target);
                const updateStateData = await client.getUpdateState(updateState);
                if (updateStateData === null) {
                    continue;
                }
                updateStates.push(updateStateData);
            }
        }
        this.updateStates = updateStates;
        return updateStates;
    }
}
exports.Avatar = Avatar;
class Trait {
    constructor(id, traitAddress, avatarClass, traitMint, attributeIds, componentUri, status, variantMetadata, equipPaymentDetails, removePaymentDetails, traitGate) {
        this.id = id;
        this.traitAddress = traitAddress;
        this.avatarClass = avatarClass;
        this.traitMint = traitMint;
        this.attributeIds = attributeIds;
        this.componentUri = componentUri;
        this.status = status;
        this.variantMetadata = variantMetadata;
        this.equipPaymentDetails = equipPaymentDetails;
        this.removePaymentDetails = removePaymentDetails;
        this.traitGate = traitGate;
    }
    isValidVariant(variantId, optionId) {
        const variant = this.variantMetadata.find((variant) => variant.id === variantId);
        if (variant === undefined) {
            return false;
        }
        return variant.options.some((opt) => opt.optionId === optionId);
    }
}
exports.Trait = Trait;
class PaymentMethod {
    constructor(index, avatarClass, assetClass, action) {
        this.index = index;
        this.avatarClass = avatarClass;
        this.assetClass = assetClass;
        this.action = action;
    }
}
exports.PaymentMethod = PaymentMethod;
class UpdateState {
    constructor(initialized, avatar, target) {
        this.initialized = initialized;
        this.avatar = avatar;
        this.target = target;
    }
    isPaid() {
        switch (this.target.kind) {
            case "classVariant":
                return this.target.paymentState
                    ? this.target.paymentState.isPaid()
                    : true;
            case "traitVariant":
                return this.target.paymentState
                    ? this.target.paymentState.isPaid()
                    : true;
            case "equipTrait":
                return this.target.paymentState
                    ? this.target.paymentState.isPaid()
                    : true;
            case "removeTrait":
                return this.target.paymentState
                    ? this.target.paymentState.isPaid()
                    : true;
            case "swapTrait":
                return ((this.target.equipPaymentState
                    ? this.target.equipPaymentState.isPaid()
                    : true) &&
                    (this.target.removePaymentState
                        ? this.target.removePaymentState.isPaid()
                        : true));
            default:
                throw new Error(`Unknown target kind: ${this.target.kind}`);
        }
    }
}
exports.UpdateState = UpdateState;
function parseUpdateTarget(data) {
    if ("classVariant" in data) {
        let paymentState = undefined;
        if (data.classVariant.paymentState) {
            paymentState = new PaymentState(new anchor.web3.PublicKey(data.classVariant.paymentState.paymentMethod), new anchor.BN(data.classVariant.paymentState.currentAmount, "hex"), new anchor.BN(data.classVariant.paymentState.requiredAmount, "hex"));
        }
        return new UpdateTargetClassVariant(data.classVariant.variantId, data.classVariant.optionId, paymentState);
    }
    if ("traitVariant" in data) {
        let paymentState = undefined;
        if (data.traitVariant.paymentState) {
            paymentState = new PaymentState(new anchor.web3.PublicKey(data.traitVariant.paymentState.paymentMethod), new anchor.BN(data.traitVariant.paymentState.currentAmount, "hex"), new anchor.BN(data.traitVariant.paymentState.requiredAmount, "hex"));
        }
        return new UpdateTargetTraitVariant(data.traitVariant.variantId, data.traitVariant.optionId, data.traitVariant.traitAccount, paymentState);
    }
    if ("equipTrait" in data) {
        let paymentState = undefined;
        if (data.equipTrait.paymentState) {
            paymentState = new PaymentState(new anchor.web3.PublicKey(data.equipTrait.paymentState.paymentMethod), new anchor.BN(data.equipTrait.paymentState.currentAmount, "hex"), new anchor.BN(data.equipTrait.paymentState.requiredAmount, "hex"));
        }
        return new UpdateTargetEquipTrait(data.equipTrait.traitAccount, paymentState);
    }
    if ("removeTrait" in data) {
        let paymentState = undefined;
        if (data.removeTrait.paymentState) {
            paymentState = new PaymentState(new anchor.web3.PublicKey(data.removeTrait.paymentState.paymentMethod), new anchor.BN(data.removeTrait.paymentState.currentAmount, "hex"), new anchor.BN(data.removeTrait.paymentState.requiredAmount, "hex"));
        }
        return new UpdateTargetRemoveTrait(data.removeTrait.traitAccount, paymentState);
    }
    if ("swapTrait" in data) {
        let equipPaymentState = undefined;
        if (data.swapTrait.equipPaymentState) {
            equipPaymentState = new PaymentState(new anchor.web3.PublicKey(data.swapTrait.equipPaymentState.paymentMethod), new anchor.BN(data.swapTrait.equipPaymentState.currentAmount, "hex"), new anchor.BN(data.swapTrait.equipPaymentState.requiredAmount, "hex"));
        }
        let removePaymentState = undefined;
        if (data.swapTrait.removePaymentState) {
            removePaymentState = new PaymentState(new anchor.web3.PublicKey(data.swapTrait.removePaymentState.paymentMethod), new anchor.BN(data.swapTrait.removePaymentState.currentAmount, "hex"), new anchor.BN(data.swapTrait.removePaymentState.requiredAmount, "hex"));
        }
        return new UpdateTargetSwapTrait(data.swapTrait.equipTraitAccount, data.swapTrait.removeTraitAccount, equipPaymentState, removePaymentState);
    }
}
exports.parseUpdateTarget = parseUpdateTarget;
function parseUpdateTargetByKind(data) {
    if ("classVariant" === data.kind) {
        let paymentState = undefined;
        if (data.paymentState) {
            paymentState = new PaymentState(new anchor.web3.PublicKey(data.paymentState.paymentMethod), new anchor.BN(data.paymentState.currentAmount, "hex"), new anchor.BN(data.paymentState.requiredAmount, "hex"));
        }
        return new UpdateTargetClassVariant(data.variantId, data.optionId, paymentState);
    }
    if ("traitVariant" === data.kind) {
        let paymentState = undefined;
        if (data.paymentState) {
            paymentState = new PaymentState(new anchor.web3.PublicKey(data.traitVariant.paymentState.paymentMethod), new anchor.BN(data.traitVariant.paymentState.currentAmount, "hex"), new anchor.BN(data.traitVariant.paymentState.requiredAmount, "hex"));
        }
        return new UpdateTargetTraitVariant(data.variantId, data.optionId, new anchor.web3.PublicKey(data.trait), paymentState);
    }
    if ("equipTrait" === data.kind) {
        let paymentState = undefined;
        if (data.paymentState) {
            paymentState = new PaymentState(new anchor.web3.PublicKey(data.equipTrait.paymentState.paymentMethod), new anchor.BN(data.equipTrait.paymentState.currentAmount, "hex"), new anchor.BN(data.equipTrait.paymentState.requiredAmount, "hex"));
        }
        return new UpdateTargetEquipTrait(new anchor.web3.PublicKey(data.traitAccount), paymentState);
    }
    if ("removeTrait" === data.kind) {
        let paymentState = undefined;
        if (data.paymentState) {
            paymentState = new PaymentState(new anchor.web3.PublicKey(data.paymentState.paymentMethod), new anchor.BN(data.paymentState.currentAmount, "hex"), new anchor.BN(data.paymentState.requiredAmount, "hex"));
        }
        return new UpdateTargetRemoveTrait(new anchor.web3.PublicKey(data.traitAccount), paymentState);
    }
    if ("swapTrait" === data.kind) {
        return new UpdateTargetSwapTrait(new anchor.web3.PublicKey(data.equipTraitAccount), new anchor.web3.PublicKey(data.removeTraitAccount));
    }
}
exports.parseUpdateTargetByKind = parseUpdateTargetByKind;
function hashUpdateTarget(updateTarget) {
    if (updateTarget instanceof UpdateTargetClassVariant ||
        updateTarget instanceof UpdateTargetSelectionClassVariant) {
        const digest = js_sha256_1.sha256.digest(`${updateTarget.variantId}${updateTarget.optionId}`);
        const buf = Buffer.from(digest);
        return buf;
    }
    if (updateTarget instanceof UpdateTargetTraitVariant ||
        updateTarget instanceof UpdateTargetSelectionTraitVariant) {
        const digest = js_sha256_1.sha256.digest(`${updateTarget.variantId}${updateTarget.optionId}${updateTarget.trait.toString()}`);
        const buf = Buffer.from(digest);
        return buf;
    }
    if (updateTarget instanceof UpdateTargetEquipTrait ||
        updateTarget instanceof UpdateTargetSelectionEquipTrait) {
        const digest = js_sha256_1.sha256.digest(`${updateTarget.traitAccount.toString()}`);
        const buf = Buffer.from(digest);
        return buf;
    }
    if (updateTarget instanceof UpdateTargetRemoveTrait ||
        updateTarget instanceof UpdateTargetSelectionRemoveTrait) {
        const digest = js_sha256_1.sha256.digest(`${updateTarget.traitAccount.toString()}`);
        const buf = Buffer.from(digest);
        return buf;
    }
    if (updateTarget instanceof UpdateTargetSwapTrait ||
        updateTarget instanceof UpdateTargetSelectionSwapTrait) {
        const digest = js_sha256_1.sha256.digest(`${updateTarget.equipTraitAccount.toString()}${updateTarget.removeTraitAccount.toString()}`);
        const buf = Buffer.from(digest);
        return buf;
    }
    throw new Error(`invalid update target: ${updateTarget}`);
}
exports.hashUpdateTarget = hashUpdateTarget;
class UpdateTargetTraitVariant {
    constructor(variantId, optionId, trait, paymentState) {
        this.kind = "traitVariant";
        this.variantId = variantId;
        this.optionId = optionId;
        this.trait = new anchor.web3.PublicKey(trait);
        if (paymentState) {
            this.paymentState = paymentState;
        }
        else {
            this.paymentState = null;
        }
    }
    format() {
        return {
            traitVariant: {
                variantId: this.variantId,
                optionId: this.optionId,
                traitAccount: this.trait,
            },
        };
    }
}
exports.UpdateTargetTraitVariant = UpdateTargetTraitVariant;
class UpdateTargetClassVariant {
    constructor(variantId, optionId, paymentState) {
        this.kind = "classVariant";
        this.variantId = variantId;
        this.optionId = optionId;
        if (paymentState) {
            this.paymentState = paymentState;
        }
        else {
            this.paymentState = null;
        }
    }
    format() {
        return {
            classVariant: {
                variantId: this.variantId,
                optionId: this.optionId,
                paymentState: this.paymentState,
            },
        };
    }
}
exports.UpdateTargetClassVariant = UpdateTargetClassVariant;
class UpdateTargetEquipTrait {
    constructor(traitAccount, paymentState) {
        this.kind = "equipTrait";
        this.traitAccount = new anchor.web3.PublicKey(traitAccount);
        if (paymentState) {
            this.paymentState = paymentState;
        }
        else {
            this.paymentState = null;
        }
    }
    format() {
        return {
            equipTrait: {
                traitAccount: this.traitAccount,
                paymentState: this.paymentState,
            },
        };
    }
}
exports.UpdateTargetEquipTrait = UpdateTargetEquipTrait;
class UpdateTargetRemoveTrait {
    constructor(traitAccount, paymentState) {
        this.kind = "removeTrait";
        this.traitAccount = new anchor.web3.PublicKey(traitAccount);
        if (paymentState) {
            this.paymentState = paymentState;
        }
        else {
            this.paymentState = null;
        }
    }
    format() {
        return {
            removeTrait: {
                traitAccount: this.traitAccount,
                paymentState: this.paymentState,
            },
        };
    }
}
exports.UpdateTargetRemoveTrait = UpdateTargetRemoveTrait;
class UpdateTargetSwapTrait {
    constructor(equiptraitAccount, removetraitAccount, equipPaymentState, removePaymentState) {
        this.kind = "swapTrait";
        this.equipTraitAccount = new anchor.web3.PublicKey(equiptraitAccount);
        this.removeTraitAccount = new anchor.web3.PublicKey(removetraitAccount);
        if (equipPaymentState) {
            this.equipPaymentState = equipPaymentState;
        }
        else {
            this.equipPaymentState = null;
        }
        if (removePaymentState) {
            this.removePaymentState = removePaymentState;
        }
        else {
            this.removePaymentState = null;
        }
    }
    format() {
        return {
            swapTrait: {
                equipTraitAccount: this.equipTraitAccount,
                removeTraitAccount: this.removeTraitAccount,
                equipPaymentState: this.equipPaymentState,
                removePaymentState: this.removePaymentState,
            },
        };
    }
}
exports.UpdateTargetSwapTrait = UpdateTargetSwapTrait;
class UpdateTargetSelectionTraitVariant {
    constructor(variantId, optionId, trait) {
        this.kind = "traitVariant";
        this.variantId = variantId;
        this.optionId = optionId;
        this.trait = new anchor.web3.PublicKey(trait);
    }
    format() {
        return {
            traitVariant: {
                variantId: this.variantId,
                optionId: this.optionId,
                traitAccount: this.trait,
            },
        };
    }
}
exports.UpdateTargetSelectionTraitVariant = UpdateTargetSelectionTraitVariant;
class UpdateTargetSelectionClassVariant {
    constructor(variantId, optionId) {
        this.kind = "classVariant";
        this.variantId = variantId;
        this.optionId = optionId;
    }
    format() {
        return {
            classVariant: { variantId: this.variantId, optionId: this.optionId },
        };
    }
}
exports.UpdateTargetSelectionClassVariant = UpdateTargetSelectionClassVariant;
class UpdateTargetSelectionEquipTrait {
    constructor(traitAccount) {
        this.kind = "equipTrait";
        this.traitAccount = new anchor.web3.PublicKey(traitAccount);
    }
    format() {
        return {
            equipTrait: { traitAccount: this.traitAccount },
        };
    }
}
exports.UpdateTargetSelectionEquipTrait = UpdateTargetSelectionEquipTrait;
class UpdateTargetSelectionRemoveTrait {
    constructor(traitAccount) {
        this.kind = "removeTrait";
        this.traitAccount = new anchor.web3.PublicKey(traitAccount);
    }
    format() {
        return {
            removeTrait: {
                traitAccount: this.traitAccount,
            },
        };
    }
}
exports.UpdateTargetSelectionRemoveTrait = UpdateTargetSelectionRemoveTrait;
class UpdateTargetSelectionSwapTrait {
    constructor(equiptraitAccount, removetraitAccount) {
        this.kind = "swapTrait";
        this.equipTraitAccount = new anchor.web3.PublicKey(equiptraitAccount);
        this.removeTraitAccount = new anchor.web3.PublicKey(removetraitAccount);
    }
    format() {
        return {
            swapTrait: {
                equipTraitAccount: this.equipTraitAccount,
                removeTraitAccount: this.removeTraitAccount,
            },
        };
    }
}
exports.UpdateTargetSelectionSwapTrait = UpdateTargetSelectionSwapTrait;
function parsePaymentAssetClass(jsonPayload) {
    if ("fungible" in jsonPayload) {
        return new FungiblePaymentAssetClass(new anchor.web3.PublicKey(jsonPayload.fungible.mint));
    }
    if ("nonFungible" in jsonPayload) {
        return new NonFungiblePaymentAssetClass(new anchor.web3.PublicKey(jsonPayload.nonFungible.mints));
    }
}
exports.parsePaymentAssetClass = parsePaymentAssetClass;
function parsePaymentAction(jsonPayload) {
    if ("transfer" in jsonPayload) {
        return new TransferPaymentAction(new anchor.web3.PublicKey(jsonPayload.transfer.treasury));
    }
    if ("burn" in jsonPayload) {
        return new BurnPaymentAction();
    }
}
exports.parsePaymentAction = parsePaymentAction;
class FungiblePaymentAssetClass {
    constructor(mint) {
        this.mint = mint;
    }
    format() {
        return { fungible: { mint: this.mint } };
    }
}
exports.FungiblePaymentAssetClass = FungiblePaymentAssetClass;
class NonFungiblePaymentAssetClass {
    constructor(mints) {
        this.mints = mints;
    }
    format() {
        return { nonFungible: { mints: this.mints } };
    }
}
exports.NonFungiblePaymentAssetClass = NonFungiblePaymentAssetClass;
class BurnPaymentAction {
    format() {
        return { burn: {} };
    }
}
exports.BurnPaymentAction = BurnPaymentAction;
class TransferPaymentAction {
    constructor(treasury) {
        this.treasury = treasury;
    }
    format() {
        return { transfer: { treasury: this.treasury } };
    }
}
exports.TransferPaymentAction = TransferPaymentAction;
